import React, { useEffect, useRef, useState } from 'react';
import { BrowserSessionApiClient } from '@/services/browserSessionApiClient';

type FolderSetupJob = { jobId: string; state: 'queued' | 'running' | 'ready' | 'needs_attention'; phase: string; completed: number; total: number; message: string };
export default function ProjectFolderSetupNotice({ projectId, enabled, refreshKey = 0, onReady }: {
  projectId: number | string | null | undefined; enabled: boolean; refreshKey?: number; onReady?: () => void;
}) {
  const [job, setJob] = useState<FolderSetupJob | null>(null);
  const [unavailable, setUnavailable] = useState(false);
  const [check, setCheck] = useState(0);
  const ready = useRef(''); const readyCallback = useRef(onReady); readyCallback.current = onReady;
  useEffect(() => {
    const id = Number(projectId);
    setJob(null); setUnavailable(false);
    if (!enabled || !Number.isSafeInteger(id) || id <= 0) return;
    let active = true, timer: ReturnType<typeof setTimeout> | undefined, polls = 0;
    const load = async () => {
      try {
        const response = await new BrowserSessionApiClient('/api').request<any>(`/api/projects/${id}/folders/provision-status`);
        if (!active) return;
        const next: FolderSetupJob | null = response?.data?.job || null;
        setJob(next); setUnavailable(false);
        if (next?.state === 'ready' && ready.current !== next.jobId) { ready.current = next.jobId; readyCallback.current?.(); }
        if (next && ['queued', 'running'].includes(next.state) && polls++ < 60) timer = setTimeout(load, 2000);
      } catch { if (active) setUnavailable(true); }
    };
    void load();
    return () => { active = false; if (timer) clearTimeout(timer); };
  }, [projectId, enabled, refreshKey, check]);
  if (!job && !unavailable) return null;
  return <div role="status" style={{ margin: '10px 0', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', color: '#243b53', fontSize: 13 }}>
    <span>{job?.message || 'Folder setup status could not be checked. This does not mean creation failed.'}
      {job?.state === 'running' && job.total > 0 ? ` ${job.completed}/${job.total} ${job.phase} processed.` : ''}
      {job && ['queued', 'running'].includes(job.state) ? ' You can close this page; setup continues in the background.' : ''}</span>
    <button type="button" onClick={() => setCheck(value => value + 1)} style={{ minHeight: 44, padding: '6px 12px', border: '1px solid #d3dce8', borderRadius: 8, background: '#fff', color: '#2251b4', cursor: 'pointer' }}>Check folder setup status</button>
  </div>;
}
